import React, { useState } from 'react';
import PropTypes from 'prop-types';

import getFlagUrl from './countryFlagAssets';

const Flag = ({ countryCode }) => {
    const src = getFlagUrl(countryCode);

    
    
    const [failedCode, setFailedCode] = useState(null);

    
    
    if (!src || countryCode === failedCode) return null;

    return (
        <span className='flag-span'>
            <img
                className='flag-icon'
                src={src}
                onError={() => setFailedCode(countryCode)}
                
                alt=''
                // Brand CSS scales .flag-icon up to undo letterboxing, so the
                // image has to letterbox rather than stretch to fill the square.
                style={{ objectFit: 'contain' }}
                
                
                width='21'
                height='14'
            />
        </span>
    );
};

Flag.defaultProps = {
    countryCode: ''
};

Flag.propTypes = {
    countryCode: PropTypes.string
};

export default Flag;
